<div class="l-transfer">
  <app-title label="Transfer" title="振替えについて"></app-title>
  <div class="l-transfer__content2">
    <app-title label="" title="子供向け"></app-title>
    <div class="l-transfer__content2__question">
      <img src="./../../../../assets/img/question-icon.png" />
      <p>振替は行ってますか？</p>
      <img src="./../../../../assets/img/anser-icon.png" />
      <p>
        当日の 12時までにご連絡をいただいた場合のみ 対応可能です。<br />
        これは、当日12時にレッスンの詳細を決定しているためです。
      </p>
    </div>
    <div class="l-transfer__content2__question">
      <img src="./../../../../assets/img/question-icon.png" />
      <p>振替の提案はいつ行われますか？</p>
      <img src="./../../../../assets/img/anser-icon.png" />
      <p>
        振替の提案は、基本的に 土曜日・日曜日・祝日に行います。<br />
        例えば、9日（木）にお休みされた場合は、11日（土）や12日（日）に振替をご提案いたします。<br />
        ただし、病気や怪我などで複数回お休みが重なる場合は、個別に調整させていただきます。
      </p>
    </div>
    <div class="l-transfer__content2__question">
      <img src="./../../../../assets/img/question-icon.png" />
      <p>振替の期限はいつまででしょうか？</p>
      <img src="./../../../../assets/img/anser-icon.png" />
      <p>
        振替期限は1カ月になります。ダイナモBスタジオでは、原則として4週分ご提案いたします。<br />
        LINEで1週間単位での提案をしております。
        これは、人数が多すぎる場合、良質なサービスの提供が難しくなる可能性があるためです。<br />
        また、長期休暇や体力測定の期間を挟む場合は、数週間単位でまとめてご提案させていただくこともございます。
      </p>
    </div>
    <div class="l-transfer__content2__question">
      <img src="./../../../../assets/img/question-icon.png" />
      <p>振替を指定したい</p>
      <img src="./../../../../assets/img/anser-icon.png" />
      <p>
        振替の指定は可能です。ただし、振替は他のレッスンがある日のみ承ります。<br />
        また、以下の場合には事前にご説明させていただきます<br />
        ・定員に達している場合<br />
        ・年齢差が大きい場合<br />
        ・運動能力に大きな差がある場合<br />
        ...etc<br />
      </p>
    </div>
  </div>
</div>
